<template>
  <div class="home">
    <Head :logo="logo"></Head>
    <van-form>
      <van-field v-model="payCode" label="电子缴款码"  placeholder="请输电子缴款码" />
      <van-field v-model="bizNumber" label="业务编码"  placeholder="请输入业务编码、批次号或通知书号" />
    </van-form>
    <van-button round block type="info" native-type="submit" @click="toPay" class="btn">下一步</van-button>
     <PrivacyDialog person='1' @getReadState='getReadState'></PrivacyDialog>
    <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>

    <van-dialog v-model="showDialog" title="提示" >
        <div class="notice">{{notice}}</div>
    </van-dialog>
  </div>
</template>

<script>
import Head from "@/components/head";
import Foot from "@/components/foot";
import { Dialog } from "vant";
import {isEmpty,savePrivacy} from '@/utils/common.js'
import {judgeVde} from "@/utils/publicJudge";
import PrivacyDialog from '@/components/dialog/privacyDialog'

export default {
  name: "bdcIndex",
  components: {
    Head,
    Foot,
    PrivacyDialog
  },
  data() {
    return {
      showDialog:false,
      notice:'',
      logo: "",
      vde: "",
      payCode: "",
      bizNumber: "",
      type: 0,
      list: [],
      isRead:false,
      details:[]
    };
  },
  created() {
    if (this.$route.query.vde === undefined) {
      this.vde = "";
    } else {
      this.vde = this.$route.query.vde;
    }
    //判断vde
    judgeVde({vde:this.vde},this)
    this.getHeadImg();
    this.getFootData();
  },
  methods: {
     getReadState(isRead,details) {
        this.isRead = isRead;
        this.details = details;
      },
      // 存储隐私授权接口
    savePrivacy() {
        let data = {
          details:this.details,
          userId:this.payCode?this.payCode:this.bizNumber,
          userName: this.payCode?this.payCode:this.bizNumber
        };
        savePrivacy(data);
    },
      getHeadImg() {
          let data = {}
          data.vde = this.vde;
          this.request({
            url:'/webPortal/websitConfig',
            method:'get',
            params:data
          }).then((res)=>{
              if (res.data.code == 1000 && res.data.result) {
                  if (res.data.result.logoUrlLogin) {
                      this.logo = res.data.result.logoUrlLogin
                  }else {
                    this.logo = require('@/assets/img/logo.png')
                    }
                  sessionStorage.setItem('title',res.data.result.websitTitle)
                  document.title=res.data.result.websitTitle 
              }else if (res.data.code != 1000){
                    this.$router.push({ path: "/404" });
              }

          })
      },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 6
      };
      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
          if (res.data.code != 1000) {
            // this.$router.push({ path: "/404" });
          } else {
            this.list = res.data.result;
          }
        
      })
    },
    toPay() {
       if (this.isRead == false) {
          Dialog.alert({
            title: "提示",
            message: "请先阅读《用户隐私政策》",
          }).then(() => {});
          return;
      };
      if (isEmpty(this.payCode)&& isEmpty(this.bizNumber)) {
        this.showDialog = true
        this.notice = '至少输入一个查询条件'
      } else {
        this.savePrivacy();
        this.$router.push({
          path:
            "/pages/bdcPay/results?type=" + this.type
                  + "&vde=" + this.vde + "&payCode=" + this.payCode + "&bizNumber=" +
            this.bizNumber + "&fromtype=1"
        });
      }
    }
  }
};
</script>


<style lang="scss">
.home {
  padding: 0 2vw;
  box-sizing: border-box;
  .van-form {
    background: rgba(255, 255, 255, 1);
    box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
    border-radius: 5px;
   .van-field__label {
      margin-right: 0;
    }
  }
  .van-cell {
    background: transparent;
  }


  .btn {
    margin-top: 30px;
  }
}
.van-dialog__header {
    background: #1989fa;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
}
.notice {
  padding: 15px 10px;
  text-align: center;
  color: #646566;
}
.van-dialog__content {
  text-align: center;
  color: #646566;
  font-size: 15px;
}
</style>